export default {
  item: "Item",
  item_model: "Model",
  corrective_work: "Performed Work, Corrective",
  corrective_work_order: "Work Order",
  regular_work: "Performed Work, Regular",
  regular_work_order: "Work Order",
  issue: "Issue",
  area: "Area",
  zone: "Zone",
}
